import React, {useEffect, useState,useRef} from "react";
import {Popconfirm,Col, Row, ConfigProvider, Button, message, Modal, DatePicker, Input} from 'antd';
import { sendHttpPostRequest } from "../../../api/http-request";
import zhCN from 'antd/lib/locale/zh_CN'
import {checkUserLogin} from "../../common/user-center/user-info";
import { EyeOutlined,DeleteOutlined } from '@ant-design/icons';

import courseMainStyles from "../course-main.module.less";
import courseExamListStyles from "./course-main-teacher-exam-list.module.less";
import courseMainTestListStyles from '../test/course-main-teacher-test-list.module.less';
import kaoshiEmpty from "../../../static/image/empty/queshengye-kaoshi.png";
import Cookies from "js-cookie";
import moment from 'moment';
import Draggable from 'react-draggable'
const { RangePicker } = DatePicker;


import Icon from '@ant-design/icons'
import  {ReactComponent as myplusSvg }   from '../../../static/image/course/myplus.svg'
const myplusIcon = (props:any) => (<Icon component={myplusSvg} {...props} />)

import  {ReactComponent as clockredSvg }   from '../../../static/image/course/clock-red.svg'
const clockredIcon = (props:any) => (<Icon component={clockredSvg} {...props} />)
import  {ReactComponent as clockgreenSvg }   from '../../../static/image/course/clock-green.svg'
const clockgreenIcon = (props:any) => (<Icon component={clockgreenSvg} {...props} />)
import  {ReactComponent as clockpurpleSvg }   from '../../../static/image/course/clock-purple.svg'
const clockpurpleIcon = (props:any) => (<Icon component={clockpurpleSvg} {...props} />)
import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
import { ReactComponent as publishSvg }   from '../../../static/image/course/publish.svg'
import { ReactComponent as deleteSvg }   from '../../../static/image/module/delete.svg'

const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
const publishIcon = (props:any) => (<Icon component={publishSvg} {...props} />)
const deleteIcon = (props:any) => (<Icon component={deleteSvg} {...props} />)


const { TextArea } = Input

export interface Props {
  course_id : any,
  college_id: any,
  enable_exam: any,
  menu_id : any,
  assistant: any,
}

const dateFormat = 'YYYY-MM-DD HH:mm:ss';

/** 教师课程考试列表页面 */
export const CourseMainTeacherExamList: React.FC<Props> = (props) => {
    const {course_id,college_id,enable_exam,menu_id,assistant} = props;

    const [examList, setExamList] = useState([] as any[]);

    const [examName, setExamName] = useState('');  // 考试名称
    const [examDescription, setExamDescription] = useState('');  // 考试说明

    /** 以下是创建作业弹出框显示用到的变量和函数 */
    const [isModalVisible, setIsModalVisible] = useState(false)
    const draggleRef = useRef<HTMLDivElement | null>(null)

    const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
    const [disabled, setDisabled] = useState(true)

    const [startTime, setStartTime] = useState(moment().utc().zone(-8).format(dateFormat).toString() as any);//考试开始时间
    const [endTime, setEndTime] = useState(moment().utc().zone(-8).add(2, 'hours').format(dateFormat).toString() as any);//考试结束时间

    const disabledDate = (current:any) => {
      return current && current < moment().startOf('day');
    }

    const onDateRangeChange = (dates,dateStrings) => {
      setStartTime(dateStrings[0]);
      setEndTime(dateStrings[1]);
     
  }


    const onStart = (event: any, uiData: any) => {
        const { clientWidth, clientHeight } = window?.document?.documentElement
        const targetRect = draggleRef?.current?.getBoundingClientRect()
        if (targetRect) {
        setBounds({
            left: -targetRect?.left + uiData?.x,
            right: clientWidth - (targetRect?.right - uiData?.x),
            top: -targetRect?.top + uiData?.y,
            bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        })
        }
    }



    function calculateTimeInterval(timeStr1, timeStr2) {
      // 将时间字符串转换为Date对象
      const date1:any = new Date(timeStr1);
      const date2:any = new Date(timeStr2);
      
      // 验证日期是否有效
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
          throw new Error("无效的时间格式，请使用'YYYY-MM-DD HH:MM:SS'格式");
      }
      
      // 计算时间差（毫秒），取绝对值确保为正数
      const timeDiffMs = Math.abs(date1 - date2);
      
      // 转换为总分钟数
      const totalMinutes = Math.floor(timeDiffMs / (1000 * 60));
      
      // 计算小时和剩余分钟
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      
      // 构建结果字符串
      const parts:any = [];
      if (hours > 0) {
          parts.push(`${hours}小时`);
      }
      if (minutes > 0) {
          parts.push(`${minutes}分钟`);
      }
      
      // 处理两个时间完全相同的情况
      return parts.length > 0 ? parts.join('') : '0分钟';
  }


    const statusStyles = (testStatus: string) => {
      if (testStatus === '进行中') { // 
        return { color: '#0ea5e9', background: '#0ea5e91a' }; // 蓝色系 - 表示活跃进行
      } else if (testStatus === '未发布') {
        return { color: '#6b7280', background: '#6b72801a' }; // 灰色系 - 表示未激活
      } else if (testStatus === '已完成') {
        return { color: '#10b981', background: '#10b9811a' }; // 绿色系 - 表示完成状态
      } else if (testStatus === '未开考') {
        return { color: '#f59e0b', background: '#f59e0b1a' }; // 橙色系 - 表示待开始
      } else if (testStatus === '阅卷中') {
        return { color: '#8b5cf6', background: '#8b5cf61a' }; // 紫色系 - 表示中间处理状态
      }
      // 默认样式，应对未定义的状态
      return { color: '#9ca3af', background: '#9ca3af1a' };
    };

    const onPublishExamClick = (exam_id:string, exam_status: any, event:any) => {
      if (!checkUserLogin()) {
          document.getElementById("show-login-modal")!.click();
      } else {
        const params = {
            sessionid: Cookies.get("sessionid"),
            exam_id: exam_id,
            status: 2,//发布状态
        };
        sendHttpPostRequest(
            'exam/api/user_update_exam/',
            params,
            (response:any) => {
                message.destroy();
                if (response.code == -100) {
                    // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
                } else if (response.code == -501) {
                    // 没权限
                    message.error("权限不足");
                } else if (response.is_ok == true) {
                    queryExamList()
                    //message.success("考试发布成功~")
                    
                }else {
                    message.error(response.message);
                }
            }
        )
        }
    }
    

    // 点击确认创建考试
    const createExam = () => {
        message.destroy()
        sendHttpPostRequest(
            'exam/api/user_create_exam/',
            {
                sessionid: Cookies.get('sessionid'),
                course_id: course_id,
                college_id: college_id,  
                name: examName,
                description: examDescription,
                start_time: startTime ,
                end_time: endTime
            },
            (response:any) => {
              message.destroy();
              if (response.code == -100) {
                // 没登录
                sessionStorage.setItem("previousurl",window.location.href )
                document.getElementById("show-login-modal")!.click();
              } else if (response.code == -501) {
                // 没权限
                message.error("权限不足")
              } else if (response.is_ok == true) {
                // 创建成功 直接 转入 新建考试编辑页面  
                // 刷新考试列表
                // 关闭弹出框
                queryExamList()
                setIsModalVisible(false)
                setExamName('')
                setExamDescription('')
                const new_exam_id = response.exam_id
                window.open('/course-teacher-exam-preview?exam_id='+new_exam_id+'&course_id='+course_id+'&menu_id=' + menu_id )
              } else {
                message.error(response.message);
              }
            }
        )
    }


    /** 确认布置考试 */
    const handleOk = () => {
        //确认创建考试
        createExam()
    }
    // 取消布置作业
    const handleCancel = () => {
        //取消创建考试
        setExamName('')
        setExamDescription('')
        setIsModalVisible(false)
    }

    // 点击删除按钮
    const onDeleteBtnClick = (examName:string, examId:number) => {

      deleteExam(examId);
    }


    useEffect(()=> {
      queryExamList();
    },[])


  const queryExamList = () => {
    if (!checkUserLogin()) {
        document.getElementById("show-login-modal")!.click();
    }
    
    sendHttpPostRequest(
      'exam/api/user_query_exam_list/',
      {
          sessionid: Cookies.get("sessionid"),
          course_id: course_id,
          college_id: college_id
      },
      queryExamListCallback
  )
  
}

    /**
     * 创建考试回调
     * @param response
     */
     const queryExamListCallback = (response:any) => {
      message.destroy();
      if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById("show-login-modal")!.click();
      } else if (response.code == -501) {
          // 没权限
          window.location.href = '/login?next=course-main-teacher?course_id=' + course_id + "&tabKey=5";
      } else if (response.is_ok == true) {
          setExamList(response.query_list);
          //console.log(response.query_list);
      }
  }

  /** 删除考试 */
  const deleteExam = (examId:any) => {
    if (!checkUserLogin()) {
        document.getElementById("show-login-modal")!.click();
    }
    
    sendHttpPostRequest(
      'exam/api/user_delete_exam/',
      {
          sessionid: Cookies.get("sessionid"),
          exam_id: examId,
      },
      deleteExamCallback
  )
  
}

    /**
     * 删除考试回调
     * @param response
     */
     const deleteExamCallback = (response:any) => {
      message.destroy();
      if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById("show-login-modal")!.click();
      } else if (response.code == -501) {
          // 没权限
          window.location.href = '/login?next=course-main-teacher?course_id=' + course_id + "&tabKey=5";
      } else if (response.is_ok == true) {
          //message.success("删除考试成功~");
          queryExamList();
      }else{
        message.error("删除考试失败~");
      }
  }



    const onPreviewExamClick = (exam_id:string) => {
          if (!checkUserLogin()) {
              document.getElementById("show-login-modal")!.click();
          }
          window.open('/course-teacher-exam-preview?exam_id=' + exam_id + "&course_id=" + course_id + "&menu_id=" + menu_id)
      }

      


  
    return (
        <div >
          <Row wrap={false} align={"middle"} style={{margin: '0 0 24px'}}>
            <Col span={12} style={{textAlign:'left'}}>
                <div className={courseMainStyles.courseTabContentTitle}>考试管理</div>
            </Col>

            <Col span={12} style={{textAlign:'right'}}>
              <div >
              
                { enable_exam &&   <span
                      style={{fontSize:14, padding:'4px 12px'}}
                      className={courseMainStyles.BtnDark}
                     onClick={()=>{setIsModalVisible(true)}} 
                  >
                    <Icon component={myplusIcon}/> 创建考试
                  </span> 
                }
                
    
              </div>
            </Col>
          </Row>

          <Row align={"middle"} gutter={[24,24]}>
            {
              examList?.map((exam, examIndex)=>(
                  <Col span={24} key={examIndex}>
                    <div className={courseMainTestListStyles.testCard}>
                        <Row wrap={false} align={"top"}>
                            <Col flex={"auto"} style={{textAlign:'left'}}>
                              <div>
                                  <div className={courseMainTestListStyles.testCardTitle} > {exam?.name} <span className={courseMainTestListStyles.statusSpan} style={statusStyles(exam?.exam_status)}> {exam?.exam_status} </span></div>
                                  <div className={courseMainTestListStyles.testCardDesp} > {exam?.description}</div>
                                  <div className={courseMainTestListStyles.testCardTimeDiv}> 
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={clockgreenIcon}/> 开始时间:  {exam?.start_time} </span>
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={clockredIcon}/> 结束时间:  {exam?.end_time} </span>
                                    <span className={courseMainTestListStyles.testCardTimeItem}  > <Icon component={clockpurpleIcon}/>  考试时长:  {calculateTimeInterval(exam?.start_time, exam?.end_time)}</span>
                                  </div>
                              </div>
                            </Col>
                            <Col flex={"300px"} style={{textAlign:'right'}}>
                              <div>
                                { exam?.exam_status == "未发布" && <span style={{fontSize:14, padding:'6px 12px'}} className={courseMainStyles.BtnDark} onClick={onPublishExamClick.bind(this,exam?.id,exam?.status)}  > <Icon component={publishIcon}/> 发布 </span> }
                                <span  style={{fontSize:14, padding:'6px 12px', marginLeft:12}} className={courseMainStyles.BtnLight} onClick={onPreviewExamClick.bind(this, exam?.id)}  > <Icon component={eyeIcon}/> 查看 </span>
                                
                                <Popconfirm placement="top" title={'确认删除考试"' + exam?.name + '"吗？'} onConfirm={onDeleteBtnClick.bind(this, exam?.name,exam?.id)} okText="确认" cancelText="取消">
                                  <span style={{fontSize:14, padding:'6px 12px', marginLeft:12, display:assistant?"none":"inline-block"}} className={courseMainStyles.BtnDelete} > <Icon component={deleteIcon}/> 删除 </span>
                                </Popconfirm>

                              </div>
                            </Col>                            
                        </Row>
                    </div>
                  </Col>
              ))
            }
          </Row>

          {examList.length==0 &&
            <div style={{textAlign:'center',paddingTop:20}}>
                <img src={kaoshiEmpty} width={120} height={120}/>
                <div style={{color:'#999',marginTop:10}}>{assistant ? '老师还没有创建考试哟~' : '您还没有创建考试哟~'}</div>
            </div>
          }
  

            <Modal
                  title={
                    <div
                      style={{
                        width: '100%',
                        cursor: 'move',
                      }}
                      onMouseOver={() => {
                        if (disabled) {
                          setDisabled(false)
                        }
                      }}
                      onMouseOut={() => {
                        setDisabled(true)
                      }}
                      onFocus={() => {}}
                      onBlur={() => {}}
                      // end
                    >
                      新建考试
                    </div>
                  }
                  closable={true}
                  open={isModalVisible}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  bodyStyle={{ minHeight: '300px' }}
                  destroyOnClose={true}
                  width={600}
                  modalRender={(modal) => (
                    <div className={courseExamListStyles.createDiv}>
                      <ConfigProvider locale={zhCN}> 
                      <Draggable
                        disabled={disabled}
                        bounds={bounds}
                        onStart={(event, uiData) => onStart(event, uiData)}
                      >
                        <div ref={draggleRef}>{modal}</div>
                      </Draggable>
                      </ConfigProvider>
                    </div>
                  )}
                >
                    <div>
                    <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:30}}>
                        <Col span={4} style={{color:"#00000073", textAlign:'left'}}>考试标题<span style={{color:'#FF4B50', marginLeft:5}}>*</span></Col>

                        <Col style={{textAlign:'left'}} span={20}> <Input style={{borderRadius:3}} value={examName} onChange={(e:any)=>{setExamName(e.target.value)}} /> </Col>
                    </Row>

                    <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:30}}>
                      <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>考试时间 <span style={{color:'#FF4B50', marginLeft:5}}>*</span> </Col>                        
                      <Col style={{textAlign:'left'}}  flex="400px">
                      { startTime && endTime &&
                      <RangePicker
                        style={{width:"100%"}}
                        disabledDate={disabledDate}
                        placeholder={["开始时间","结束时间"]}
                        showTime={{ format: 'HH:mm:ss' }}
                        format="YYYY-MM-DD HH:mm:ss"
                        onChange={onDateRangeChange}
                        allowClear={false} 
                        allowEmpty = {[false, false]}
                        onOk={()=>{}}
                        defaultValue={[moment(startTime,dateFormat), moment(endTime,dateFormat)]}
                        separator={<div style={{marginRight:20}}>到</div>}
                      />
                    }
                        </Col>
                      
                  </Row>

                        <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:30}}>
                        <Col span={4} style={{color:"#00000073", textAlign:'left'}}>考试说明 <span style={{color:'#FF4B50', marginLeft:5}}>*</span> </Col>
                        <Col span={20}>
                            <TextArea
                                style={{borderRadius:6}}
                                rows={6}
                                showCount={true}
                                maxLength={1000}
                                value={examDescription}
                                onChange={(e: any)=>{setExamDescription(e.target.value)}}
                            ></TextArea>
                        </Col>
                    </Row>
                    </div>
                </Modal>
        </div>
    )

}

export default CourseMainTeacherExamList

